<template>
  <div class="row m-3" v-for="issue in issues" :key="issue.id">
    <div class="col-4">
      <div class="row">
        <div class="col">{{ issue.file_name }}</div>
      </div>
      <div class="row">
        <div class="col">({{ issue.uploaded_at }})</div>
      </div>
    </div>
    <div class="col">
      <download-button @click="doDownload(issue.uuid)" />
    </div>
  </div>
  <div v-if="withPassword" class="form-group row m-3">
    <label class="col-4 col-form-label text-end">ダウンロードパスワード</label>
    <div class="col-auto">
      <input type="password" class="form-control" :class="errorMessage ? 'is-invalid' : ''" v-model="password">
      <div class="invalid-feedback">{{ errorMessage }}</div>
    </div>
  </div>
</template>

<script>
import DownloadButton from '@/views/molecules/buttons/DownloadButton'

export default {
  name: 'FileDownloadFormItem',
  emits: ['download', 'update:modelValue'],
  components: {
    DownloadButton,
  },
  props: {
    issues: {
      type: Array,
      required: true,
    },
    withPassword: {
      type: Boolean,
      default: false,
    },
    errorMessage: {
      type: [String, null],
      default: null,
    },
    modelValue: {
      type: String,
      default: '',
    }
  },
  computed: {
    password: {
      get() {
        return this.modelValue;
      },
      set(value) {
        this.$emit('update:modelValue', value);
      },
    },
  },

  methods: {
    doDownload(uuid) {
      this.$emit('download', {uuid})
    }
  },
}
</script>
